import { Tag } from '@wix/design-system'
import cs from 'classnames'
import React, { FC } from 'react'

import { wixMobileCategorySuggestionsDataHooks } from './WixMobileCategorySuggestions.dataHooks'
import s from './WixMobileCategorySuggestions.scss'

export type SuggestionContent = {
  label: string
}

interface WixMobileCategorySuggestionsProps {
  suggestions: SuggestionContent[]
  onSuggestionClick: (suggestion: string, index: number) => void
  skin?: 'default' | 'harmony'
  dataHook?: string
}

export const WixMobileCategorySuggestions: FC<WixMobileCategorySuggestionsProps> = ({
  suggestions,
  onSuggestionClick,
  skin = 'default',
  dataHook,
}) => {
  const isHarmony = skin === 'harmony'
  return (
    <div className={cs(s.container, { [s.harmony]: isHarmony })} data-hook={dataHook}>
      {suggestions.map((suggestion, index) => (
        <Tag
          key={suggestion.label}
          id={suggestion.label}
          onClick={() => onSuggestionClick(suggestion.label, index)}
          size="medium"
          removable={false}
          className={cs(s.item, { [s.harmonyItem]: isHarmony })}
          dataHook={wixMobileCategorySuggestionsDataHooks.suggestion({ key: suggestion.label })}
        >
          {suggestion.label}
        </Tag>
      ))}
    </div>
  )
}
